/* tslint:disable */
/* eslint-disable */
/**
 * SLOeats API
 * Interal API to the SLOeats platform.
 *
 * The version of the OpenAPI document: 
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import type { Notification } from './Notification';
import {
    NotificationFromJSON,
    NotificationFromJSONTyped,
    NotificationToJSON,
} from './Notification';
import type { StatusEnum } from './StatusEnum';
import {
    StatusEnumFromJSON,
    StatusEnumFromJSONTyped,
    StatusEnumToJSON,
} from './StatusEnum';

/**
 * 
 * @export
 * @interface NotificationInstance
 */
export interface NotificationInstance {
    /**
     * 
     * @type {number}
     * @memberof NotificationInstance
     */
    readonly id: number;
    /**
     * 
     * @type {Notification}
     * @memberof NotificationInstance
     */
    notification: Notification;
    /**
     * 
     * @type {StatusEnum}
     * @memberof NotificationInstance
     */
    readonly status: StatusEnum | null;
    /**
     * 
     * @type {Date}
     * @memberof NotificationInstance
     */
    readonly sent_at: Date;
}

/**
 * Check if a given object implements the NotificationInstance interface.
 */
export function instanceOfNotificationInstance(value: object): boolean {
    let isInstance = true;
    isInstance = isInstance && "id" in value;
    isInstance = isInstance && "notification" in value;
    isInstance = isInstance && "status" in value;
    isInstance = isInstance && "sent_at" in value;

    return isInstance;
}

export function NotificationInstanceFromJSON(json: any): NotificationInstance {
    return NotificationInstanceFromJSONTyped(json, false);
}

export function NotificationInstanceFromJSONTyped(json: any, ignoreDiscriminator: boolean): NotificationInstance {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'id': json['id'],
        'notification': NotificationFromJSON(json['notification']),
        'status': StatusEnumFromJSON(json['status']),
        'sent_at': (new Date(json['sent_at'])),
    };
}

export function NotificationInstanceToJSON(value?: NotificationInstance | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'notification': NotificationToJSON(value.notification),
    };
}

